import { PaymentSplit } from "@/interfaces/payment-splits/PaymentSplit"
import { useAxios } from "./useAxios"
import { Pagination } from "@/interfaces/Pagination"

const axios = useAxios()

export interface CreatePaymentSplitDTO {
  amount: number
  percentage: number
  commissionRecipientOrganizationId: string
}

export interface UpdatePaymentSplitDTO {
  amount?: number
  percentage?: number
  commissionRecipientOrganizationId?: number
}

export interface GetAllPaymentSplitsParams {
  page?: string
  perPage?: string
}

export function usePaymentSplit() {
  const create = async (payload: CreatePaymentSplitDTO): Promise<PaymentSplit> => {
    const response = await axios.post(`/payment-splits`, payload)

    return response.data
  }

  const update = async (id: number, payload: UpdatePaymentSplitDTO): Promise<void> => {
    await axios.patch(`/payment-splits/${id}`, payload)
  }

  const getAll = async (params?: GetAllPaymentSplitsParams): Promise<Pagination<PaymentSplit>> => {
    if (params) {
      params = Object.fromEntries(
        Object.entries(params).filter(([param, value]) => !!value)
      )
    }

    const response = await axios.get(`/payment-splits`, { params })

    return response.data
  }

  const destroy = async (id: number): Promise<void> => {
    await axios.delete(`/payment-splits/${id}`)
  }

  return {
    create,
    getAll,
    update,
    destroy
  }
}